<template>
  <div class="app-header">
    <div class="container">
      <div class="app-header__row">
        <logo class="logo-app-header" />
        <div v-if="isRaceLive" class="race-status">📢 Live Now</div>
        <div class="main">
          <div class="title">
            Trainer Console
          </div>
          <ul>
            <li>
              <router-link to="/admin/live-run">Liverun</router-link>
            </li>
            <li>
              <router-link to="/admin/races">Schedule</router-link>
            </li>
            <li>
              <router-link to="/admin/past-run" >Past Runs</router-link>
            </li>
            <li>
              <router-link to="/admin/scheduled-runs">Scheduled Runs</router-link>
            </li>
            <li>
              <router-link to="/admin/runners/allrunners" >Runners</router-link>
            </li>
            <li>
              <router-link to="/admin/trainers" >Trainers</router-link>
            </li>
            <li>
              <router-link to="/admin/medal" >Medal</router-link>
            </li>
            <li>
              <router-link to="/admin/settings" >Settings</router-link>
            </li>

             <li>
              <router-link to="/admin/TP" >TP</router-link>
            </li>
             <li>
              <router-link to="/admin/AR&TD">AR&TD</router-link>
            </li>

            <li>
               <select  class="more-select" v-model="selected"  @change="handleSelect()" >
                <option value='' disabled selected>More</option>
                <option value="promo-codes" >Promo Codes</option>
                <option value="logs" >Logs</option>
                <option value="mongodb" >MongoDB</option>
                <option value="firebase-stats" >Firebase</option>
              </select>
            </li>
          </ul>
        </div>
        <user-info/>
      </div>
    </div>
  </div>
</template>

<script>
  import Logo from '@/components/AppHeader/Logo'
  import UserInfo from '@/components/AppHeader/UserInfo'
  import PastRun from '@/components/LiveRun/Race/PastRun'
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  export default {
    name: 'AppHeader',
    data: () => ({
      selected:''
    }),
    components: {
      Logo,
      UserInfo,
      PastRun
    },
    computed: mapGetters({
      isRaceLive: 'Race/isRaceLive',
      template: '#modal-template'
    }),
    watch: {
      isRaceLive() {
        //console.log(this.isRaceLive)
      },
    },
    methods:{
      handleSelect(){
        this.$router.push(`/admin/${this.selected}`)
      },
      setSelection(path){
        if(path.name =='promo-codes'){
          this.selected='promo-codes'
        }else if(path.name =='logs'){
          this.selected='logs'
        }else if(path.name =='mongodb'){
          this.selected='mongodb'
        }else if(path.name =='firebase-stats'){
          this.selected='firebase-stats'
        }else{
           this.selected=''
        }
      },
    },
    created() {
      this.setSelection(this.$route)
    },    
    watch: {
      $route(to, from) {
        this.setSelection(to)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .more-select option
    color black

  .more-select option:disabled
    color grey 

  select.more-select 
    padding 2px
    margin-top -4px
    background transparent
    color white
    outline none

  .app-header
    background #423799
    padding 15px 0

    &__row
      display flex
      flex-flow row wrap
      justify-content space-between
      align-items center

    .logo-app-header
      //flex 1 0 100%
      //max-width calc(2.5/12 * 100% - (1 - 2.5/12) * 1px)

    .main
      text-align center

      .title
        font-size 22px
        color #fff

      ul
        list-style none
        display flex
        flex-flow row wrap
        justify-content center
        margin 10px 0 0

        li
          a
            border-bottom 2px solid transparent
            color #fff
            text-decoration none
            text-transform uppercase

            &.router-link-active
              border-bottom 2px solid #fff

          &:not(:last-child)
            margin 0 25px 0 0

    .user-info
      // flex 1 0 100%
      max-width calc(2.5/12 * 100% - (1 - 2.5/12) * 1px)

  .race-status
    position absolute
    margin-left 155px
    background-color #50ad69
    padding 5px 10px
    border-radius 3px
    color #fff
    margin-top -10px

  @media screen and (max-width: 900px){
      .user-info{
        margin: 10px auto;
        max-width: initial !important
      }  
      .logo-app-header{
        margin:auto
      }    
      .main ul li {
          margin-bottom: 10px!important;
      }
  }

</style>




// WEBPACK FOOTER //
// AppHeader.vue?333f03d2